import { Network, Shield, Zap } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { ScoreChip } from './ScoreChip'

export function ScoreBandLegend() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <span className="text-3xs text-[var(--muted-foreground)] font-medium mr-1">Legend:</span>
      <span className="inline-flex items-center gap-1 text-3xs bg-[var(--muted)] px-1.5 py-0.5 rounded">
        <ScoreChip value={87} />
        <ScoreChip value={54} />
        <ScoreChip value={22} />
        <span className="text-[var(--muted-foreground)]">— {t('insights.legendScore')}</span>
      </span>
      <span className="inline-flex items-center gap-1 text-3xs bg-[var(--muted)] px-1.5 py-0.5 rounded">
        <Zap className="size-2.5 text-[var(--chart-1)]" />
        <span className="text-[var(--muted-foreground)]">{t('insights.legendBridgeNode')}</span>
      </span>
      <span className="inline-flex items-center gap-1 text-3xs bg-[var(--muted)] px-1.5 py-0.5 rounded">
        <Shield className="size-2.5 text-[var(--destructive)]" />
        <span className="text-[var(--muted-foreground)]">{t('insights.legendSuspect')}</span>
      </span>
      <span className="inline-flex items-center gap-1 text-3xs bg-[var(--muted)] px-1.5 py-0.5 rounded">
        <span className="font-mono text-[var(--muted-foreground)]">N</span>
        <span className="text-[var(--muted-foreground)]">{t('insights.legendSourceDocs')}</span>
      </span>
      <span className="inline-flex items-center gap-1 text-3xs bg-[var(--muted)] px-1.5 py-0.5 rounded">
        <Network className="size-2.5 text-[var(--muted-foreground)]" />
        <span className="text-[var(--muted-foreground)]">{t('insights.legendCluster')}</span>
      </span>
    </div>
  )
}
